import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA_d183DlNGjhpRgFwiOYp4lQCfg9XxsAQ",
  authDomain: "chat-messenger-123.firebaseapp.com",
  projectId: "chat-messenger-123",
  storageBucket: "chat-messenger-123.firebasestorage.app",
  messagingSenderId: "51728033921",
  appId: "1:51728033921:web:e3bbd0a639c91329a8c580",
  measurementId: "G-LX7VG85HVD"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// Keep users signed in across refreshes and normal browser restarts.
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Could not enable persistent sign-in", error);
});
